// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translation.json';
import translationZH from './locales/zh/translation.json';
import translationVI from './locales/vi/translation.json';

const resources = {
    en: {
        translation: translationEN
    },
    zh: {
        translation: translationZH
    },
    vi: {
        translation: translationVI
    }
};

i18n
    .use(Backend) // 加载翻译文件
    .use(LanguageDetector) // 自动检测浏览器语言
    .use(initReactI18next) // 通过react-i18next绑定
    .init({
        resources,
        lng: "zh",
        fallbackLng: "en",
        detection: {
            // 不查 navigator/htmlTag（puppeteer 抓取时 Accept-Language=en 会覆盖 zh）
            // 优先查项目自定义的 lang key（与 App.js / router / index.js 保持一致）
            order: ['localStorage', 'querystring', 'cookie', 'sessionStorage'],
            lookupLocalStorage: 'lang',
            caches: ['localStorage'],
        },
        debug: true,
        interpolation: {
            escapeValue: false, // 不需要HTML转义
        }
    });

export default i18n;
